import { ExpenseType, FinanceType, TransactionType } from "@/enums/enums";
import { GetCredential, GetCustomizeData, GetDocumentData } from "@/helper/documentFacadeHelper";
import { GetDocumentNameForTransaction } from "@/helper/documentHelper";
import { i18n } from "@/i18n";
import { DocumentDetailModel, OnlineViewCustomizeModel } from "@/model/document/documentModel";

export function ConvertToCustomizeOnlineView(detail: any): OnlineViewCustomizeModel {
  const onlineViewModel: OnlineViewCustomizeModel = new OnlineViewCustomizeModel();
  if (detail) {
    const documentDetailModel: DocumentDetailModel = new DocumentDetailModel();
    documentDetailModel.version = detail.document.version;
    documentDetailModel.data = GetDocumentData(detail.document.data);
    onlineViewModel.document = documentDetailModel;
    onlineViewModel.customize = GetCustomizeData(detail.customize);
    onlineViewModel.transactionId = detail.transactionId;
    onlineViewModel.transactionType = detail.transactionType;
    onlineViewModel.financeType = detail.financeType;
    onlineViewModel.expenseType = detail.expenseType;
    onlineViewModel.credential = GetCredential(detail.credential);
  }
  return onlineViewModel;
}

export function ConvertToCustomizeIdList(
  customizeIdList: Array<any>,
  transactionType: TransactionType,
  financeType: FinanceType,
  expenseType: ExpenseType
) {
  const customizeIdListModel: Array<any> = [];
  if (customizeIdList && customizeIdList.length > 0) {
    customizeIdListModel.push({
      id: "",
      name: GetDocumentNameForTransaction(transactionType, financeType, expenseType, false),
    });
    customizeIdList.forEach((customize, index) => {
      if (customize.id) {
        customizeIdListModel.push({
          id: customize.id,
          name: `${i18n.t("Customize_Format")} ${index + 1}`,
        });
      }
    });
  }

  return customizeIdListModel;
}

export function PrepareCustomizeDocumentPublicLinkInputData(input: any){
  const data = {
      customizeId: input.customizeId,
      passCode: input.passCode,
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      financeType: input.financeType,
      expenseType: ExpenseType.None,
  };
  return data;
}

export function PrepareCustomizeDocumentInputData(input: any){
  const data = {
      customizeId: input.customizeId,
      transactionId: input.transactionId,
      transactionType: input.transactionType,
      financeType: input.financeType,
      expenseType: ExpenseType.None,
  };
  return data;
}

export function PrepareCustomizeIdListInputData(input: any){
  const data = {
      transactionType: input.transactionType,
      financeType: input.financeType,
  };
  return data;
}